import { render } from "./layout-header.vue?vue&type=template&id=42dd21ef&scoped=true"
import script from "./layout-header.vue?vue&type=script&lang=js"
export * from "./layout-header.vue?vue&type=script&lang=js"

import "./layout-header.vue?vue&type=style&index=0&id=42dd21ef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42dd21ef"]])

export default __exports__